/* eslint-disable func-names */
/* eslint-disable no-extend-native */
function cloneObject(obj) {
    RegExp.prototype.toJSON = function () {
        return this.source;
    };

    return JSON.parse(JSON.stringify(obj));
}

export { cloneObject };
